import { Component } from 'react'
import forgotPasswordImg from '../../../../assets/images/forgot_password.png'
import checkImg from '../../../../assets/images/check.png'
import { Link } from 'react-router-dom'
import { OTPInput } from '../../../components/otp-input'
import { ErrorMessage, emptyField, errorsLength, formatErrors } from '../../../../insfrastructure/utils/form-validators'
import { SubmitBtn } from '../../../components/submit'
import { changePassword, validateOTP } from '../../../../insfrastructure/services/auth'
import { setTokensAfterLogin, clearAllTokens } from '../../../../insfrastructure/services/token-manager'
import { withRouter } from '../../../../insfrastructure/utils/with-router-component'
import ResponseModal from '../../../components/response-modal'
import './styles.sass'


class ValidateToken extends Component<any> {
    state: any = {
        form: {
            code: ''
        },
        formErrors: {},
        loading: false,
        sended: false,
        userdata: {}
    }

    async componentDidMount() {
        // const parsedJWT = parseJwt(localStorage.getItem('auth_token') + '');        

        // if (parsedJWT) {
        //     let userdata = {};

        //     if (parsedJWT.candidate_id) {
        //         userdata = await retrieveCandidate();
        //     } else {
        //         userdata = await retrieveCompanyManager();
        //     };

        //     this.setState({ userdata });
        // };
    }

    onSubmit = async () => {
        this.setState({ formErrors: {} });
        const errors = formatErrors({
            code: [emptyField(this.state.form.code, 'string')],
        });

        if(errorsLength(errors) > 0) {
            this.setState({ formErrors: errors }, () => {
                const firstErrorElement = document.querySelector('.errors .error') as HTMLElement | null;
                if (firstErrorElement && typeof firstErrorElement.scrollIntoView === 'function') {
                    firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });

            return;
        };

        this.setState({ loading: true });
        
        try {
            const response = await validateOTP({ code: this.state.form.code, email: this.props.location.state.email });

            setTokensAfterLogin(response.data.access, response.data.refresh);
            
            await changePassword(this.props.location.state);

            // Se veio do perfil, não limpar os tokens para manter o usuário logado
            const fromProfile = this.props.location?.state?.fromProfile || false;
            if (!fromProfile) {
            clearAllTokens();
            }

            setTimeout(() => {
                this.setState({ sended: true, loading: false });
            });
        } catch (error: any) {
            let responseData = {
                type: 'error',
                title: 'Token inválido ou expirado',
                text: () => <></>
            };

            clearAllTokens();
            this.setState({ responseData, loading: false });
        }
    }

    render() {
        return (
            <div className='reset-password unlogged-page'>
                <div className='content'>
                    <div className='block'>
                        {window.innerWidth > 1000 &&
                        <div className='img-container'>
                            <img src={forgotPasswordImg} alt='forgot-password-image' />
                        </div>}
                        {
                            !this.state.sended ?
                            <div className='block-content not-sended'>
                                <div className='text'>
                                    <h3>Insira o código enviado para seu email</h3>
                                </div>
                                <div className='form'>
                                    <OTPInput
                                        value={this.state.form.code}
                                        onChange={(value) => this.setState({ form: {...this.state.form, code: value}, formErrors: { ...this.state.formErrors, code: [] } })}
                                        onComplete={(value) => {
                                            // Auto-submit quando código completo
                                            this.setState({ form: {...this.state.form, code: value}, formErrors: { ...this.state.formErrors, code: [] } }, () => {
                                                this.onSubmit();
                                            });
                                        }}
                                        length={6}
                                        placeholder='000000'
                                        autoFocus
                                        disabled={this.state.loading}
                                    />
                                    <ErrorMessage errors={this.state.formErrors['code']} />
                                </div>
                                <p className='bottom-text'>Ao <b>confirmar</b>, sua <b>senha</b> será alterada.</p>
                                <SubmitBtn className='secondary' text='Confirmar' loadingText='Enviando...' loading={this.state.loading} onSubmit={this.onSubmit} />
                            </div> :
                            <div className='block-content sended'>
                                <div className='text'>
                                    <img className='check' src={checkImg} alt='check-image' />
                                    <h3>Senha alterada com sucesso!</h3>
                                </div>
                                {this.props.location?.state?.fromProfile ? (
                                    <Link to='/profile/job-manager'><SubmitBtn className='secondary' text='OK' /></Link>
                                ) : (
                                <Link to='/login'><SubmitBtn className='secondary' text='OK' /></Link>
                                )}
                            </div>
                        }
                    </div>
                </div>
                <ResponseModal
                render={this.state.responseData}
                type={this.state.responseData?.type}
                title={this.state.responseData?.title}
                text={this.state.responseData?.text}
                onClose={() => {
                    const fromProfile = this.props.location?.state?.fromProfile || false;
                    this.props.navigate(fromProfile ? '/profile/job-manager' : '/login');
                }} />
            </div>
        )
    }
}

export default withRouter(ValidateToken);